import { useParams } from 'react-router'
import { withAuth } from 'pages/ProtectedPage'
import { AreasList } from 'components/areas/AreasList'
import { BlocksList } from 'components/blocks/BlocksList'

export const AreaPage = () => {
  const { areaId } = useParams<{ areaId: string }>()

  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-2 tw-min-w-full tw-min-h-fit">
      <div className={'tw-col-span-1'}>
        <AreasList areaId={areaId} />
      </div>
      <div className={'tw-col-span-1 md:tw-col-span-3 md:tw-border-l md:tw-border-slate-100 md:tw-pl-4'}>
        <BlocksList areaId={areaId} />
      </div>
    </div>
  )
}

export const AreaPageProtected = withAuth(AreaPage)
